// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Map } from "@mgs/ci2019-common/src/components/shared/map/Map";
import { Api } from "#/api";
import { BodyBuilder } from "#/common/interfaces/conversionworld/BodyBuilder";
import { StageLoading } from "../stage_loading/StageLoading";
@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    StageLoading,
    MgsMap: Map,
  },
})
export class AbhSteckbriefKontaktModule extends ModuleBase {
  private readonly page = this.$store.page.page!;

  public bodyBuilder: BodyBuilder | null = null;

  private customMarkerIcon = new H.map.Icon(
    '<svg  width="28" height="40" viewBox="0 0 362.1 512" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill="#333333" d="M362.1,180C362.1,80.6,281,0,181,0S0,80.6,0,180c0,86.9,62,159.4,144.4,176.3L181,512l36.7-155.7' +
      '   C300.1,339.4,362.1,266.9,362.1,180z"/>' +
      '<circle fill="#ffffff" cx="181" cy="180.5" r="155"/>' +
      '<polygon fill="#333333" points="175,129.5 163.8,164.4 127.6,164.4 123.9,175.7 153.2,197 142,231.4 151.7,238.5 181,217.2' +
      '   210.4,238.5 220.1,231.4 208.9,197 238.2,175.7 234.5,164.4 198.3,164.4 187.1,129.5"/>' +
      "</svg>",
    { size: { w: 29, h: 40 }, crossOrigin: false }
  );

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  async created() {
    const builderId = this.page.route_parameter.abhId;
    const pageId = this.page.id;
    this.getAbhData(builderId, pageId);
  }

  public async getAbhData(id, pageId) {
    this.bodyBuilder = await this.$store.conversionWorld.getBodyBuilder(
      id,
      pageId
    );
  }

  get headline() {
    return this.instance["translation"].headline;
  }

  get ansprechpartner() {
    return this.instance["translation"].ansprechpartner;
  }

  get websiteLinkText() {
    return this.instance["translation"].websiteLinkText;
  }

  get optionalData() {
    return this.instance["optional"].address;
  }

  get vanPartnerText() {
    if (this.optionalData.vanpartner_vansolution_text) {
      return this.optionalData.vanpartner_vansolution_text;
    } else {
      return this.instance["translation"].vanpartner;
    }
  }

  get abhName() {
    if (this.optionalData.abhname) {
      return this.optionalData.abhname;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.name;
    }

    return "";
  }

  get contactName() {
    if (this.optionalData.fullname) {
      return this.optionalData.fullname;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.name;
    }

    return "";
  }

  get tel() {
    if (this.optionalData.phone) {
      return this.optionalData.phone;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.tel;
    }

    return "";
  }

  get mobile() {
    if (this.optionalData.mobile) {
      return this.optionalData.mobile;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.mobile;
    }

    return "";
  }

  get fax() {
    if (this.optionalData.fax) {
      return this.optionalData.fax;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.fax;
    }

    return "";
  }

  get email() {
    if (this.optionalData.email) {
      return this.optionalData.email;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.e_mail;
    }

    return "";
  }

  get url() {
    if (this.optionalData.link) {
      return this.optionalData.link;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.contact.url;
    }

    return "";
  }

  get street() {
    if (this.optionalData.street) {
      return this.optionalData.street;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.address.street;
    }

    return "";
  }

  get postCode() {
    if (this.optionalData.location) {
      return this.optionalData.location;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.address.post_code;
    }

    return "";
  }

  get city() {
    if (this.optionalData.location) {
      return "";
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.address.city;
    }

    return "";
  }

  get lat() {
    if (this.optionalData.lat) {
      return this.optionalData.lat;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.location.lat;
    }

    return 0;
  }

  get lng() {
    if (this.optionalData.lng) {
      return this.optionalData.lng;
    }

    if (this.bodyBuilder) {
      return this.bodyBuilder.location.lng;
    }

    return 0;
  }

  get logoImage() {
    if (this.bodyBuilder) {
      return this.bodyBuilder.images.logo_5x2;
    }

    return "";
  }

  get logoImageThumb() {
    if (this.bodyBuilder) {
      return this.bodyBuilder.images.logo_5x2_thumb;
    }

    return "";
  }

  get locationImage() {
    if (this.bodyBuilder) {
      return this.bodyBuilder.images.location_4x3;
    }

    return "";
  }
}
